import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div<{
  hasBanner: boolean;
  newBackground: boolean;
}>`
  background: ${({ newBackground }) =>
    newBackground ? themeStyle.varBackgroundAlt : themeStyle.varBackgroundBase};
  position: relative;
  top: ${({ hasBanner }) => (hasBanner ? 'var(--banner-height)' : '0px')};
`;

export const ContentWrapper = styled.div<{
  forceDarkModeContent?: boolean;
  hideHeader?: boolean;
}>`
  padding-top: ${({ hideHeader }) =>
    hideHeader ? '0px' : 'var(--header-height)'};
  ${({ forceDarkModeContent }) =>
    forceDarkModeContent ? `background: ${themeStyle.darkBackgroundBase};` : ''}
`;
